import gql from "graphql-tag";

export default gql`
  query getCreditCommentaryByFriendlyEntity($friendly_entity_id: String!, $query: QueryInput, $offset: OffsetInput) {
    getCreditCommentaryByFriendlyEntity(
      friendly_entity_id: $friendly_entity_id
      query: $query
      offset: $offset
    ) {
      __typename
      id
      friendly_entity_id
      subject_type
      subject_id
      effective_time
      category
      detail
      current
      user
    }
  }
`;